<template>
  <div class="manual-socials">
    <ManualText
      >По любым вопросам обращайтесь в<br />
      наш
      <a
        href="https://discord.gg/GNAVsJD"
        class="app-link_theme_warm text-underline"
        target="_blank"
        >Дискорд-канал</a
      >
      и в группу в
      <a
        href="https://vk.com/redbullgaming"
        class="app-link_theme_warm text-underline"
        target="_blank"
        >ВК</a
      ></ManualText
    >
  </div>
</template>

<script>
import ManualText from "./ManualText";

export default {
  components: {
    ManualText
  }
};
</script>

<style lang="scss">
.manual-socials {
  margin: 50px 0;
  text-align: center;
}
</style>
